<template>
	<div class="text-body">
		<h2>{{data.title}}</h2>
		<p class="abstract" v-for="item in data.abstract" :key="item.name">{{item}}</p>
		<div class="item" v-for="item in data.item" :key="item.name">
			<h4>{{item.title}}</h4>
			<div class="content">
				<p v-for="(item,index) in item.content" :key="index">{{item}}</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'TextTemp',
		props: ['data']
	}
</script>

<style>
	@media(min-width:992px) {
		.text-body {}

		.text-body h2 {
			line-height: initial;
			margin-top: 12px;
			font-size: 20px;
			font-family: MicrosoftYaHei;
			color: rgba(51, 51, 51, 1);
			font-weight: 500;
			text-align: left;
		}

		.text-body .abstract {
			text-indent: 2em;
			margin-top: 35px;
			line-height: 28px;
			font-size: 14px;
			font-family: MicrosoftYaHei;
			color: rgba(132, 132, 132, 1);
			text-align: left;
		}

		.text-body h4 {
			text-indent: 2em;
			margin-top: 35px;
			line-height: 28px;
			text-align: left;
			font-weight: bold;
			font-size: 14px;
			font-family: MicrosoftYaHei;
			color: rgba(132, 132, 132, 1);
		}

		.text-body .content {
			margin-top: 35px;
		}

		.text-body .content p {
			text-indent: 2em;
			line-height: 28px;
			font-size: 14px;
			font-family: MicrosoftYaHei;
			color: rgba(132, 132, 132, 1);
			text-align: left;
		}
	}

	@media(max-width:992px) {
		.text-body {}

		.text-body h2 {
			line-height: initial;
			margin-top: 6px;
			font-size: 18px;
			font-family: MicrosoftYaHei;
			color: rgba(51, 51, 51, 1);
			font-weight: 500;
			text-align: left;
		}

		.text-body .abstract {
			text-indent: 2em;
			margin-top: 20px;
			line-height: 1.5;
			font-size: 14px;
			font-family: MicrosoftYaHei;
			color: rgba(132, 132, 132, 1);
			text-align: left;
		}

		.text-body h4 {
			text-indent: 2em;
			margin-top: 20px;
			line-height: 1.5;
			text-align: left;
			font-weight: bold;
			font-size: 14px;
			font-family: MicrosoftYaHei;
			color: rgba(132, 132, 132, 1);
		}

		.text-body .content {
			margin-top: 20px;
		}

		.text-body .content p {
			text-indent: 2em;
			line-height: 1.5;
			font-size: 14px;
			font-family: MicrosoftYaHei;
			color: rgba(132, 132, 132, 1);
			text-align: left;
		}

	}
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/TextTemp.vue